(function () {
  if (window.__moneyCounterSaleDe && window.__moneyCounterSaleDe.version === 2) {
    window.__moneyCounterSaleDe.initAll(document);
    return;
  }
  function applyFilter(filter) {
    var cards = Array.from(document.querySelectorAll('[data-money-counter-product-card]'));
    var buttons = Array.from(document.querySelectorAll('[data-money-counter-filter]'));
    var count = 0;
    cards.forEach(function (card) { var show = filter === 'all' || card.dataset.moneyCounterCategory === filter; card.hidden = !show; if (show) count += 1; });
    buttons.forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.moneyCounterFilter === filter)); });
    var status = document.querySelector('[data-money-counter-filter-status]');
    if (status) status.textContent = count + (count === 1 ? ' Modell wird angezeigt.' : ' Modelle werden angezeigt.');
    var products = document.querySelector('#money-counter-best-sellers');
    if (products) products.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function initReviews(root) {
    if (!root || root.dataset.reviewCarouselVersion === '2') return;
    root.dataset.reviewCarouselVersion = '2';
    var section = root.closest('[data-money-counter-module="reviews"]') || root.parentElement;
    var list = root.querySelector('[data-review-list]');
    var slides = list ? Array.from(list.querySelectorAll('[data-review-slide]')) : [];
    var pagination = root.querySelector('[data-review-pagination]');
    var status = section ? section.querySelector('[data-review-status]') : null;
    var index = 0;
    function perPage() { return window.innerWidth <= 700 ? 1 : (window.innerWidth <= 990 ? 2 : 3); }
    function pages() { return Math.max(1, Math.ceil(slides.length / perPage())); }
    function update() {
      if (!list || !pagination) return;
      index = Math.max(0, Math.min(index, pages() - 1));
      var distance = root.clientWidth + 16;
      list.style.transform = 'translate3d(-' + (index * distance) + 'px, 0, 0)';
      pagination.innerHTML = Array.from({ length: pages() }, function (_, i) { return '<li><button class="splide__pagination__page' + (i === index ? ' is-active' : '') + '" type="button" data-review-page="' + i + '" aria-label="Seite ' + (i + 1) + '"></button></li>'; }).join('');
      if (status) status.textContent = 'Bewertungsseite ' + (index + 1) + ' von ' + pages();
    }
    root.__moneyCounterReviewGoTo = function (page) { index = page; update(); };
    root.__moneyCounterReviewStep = function (direction) { index = (index + direction + pages()) % pages(); update(); };
    if (pagination) pagination.addEventListener('click', function (event) { var button = event.target.closest('[data-review-page]'); if (button) { index = Number(button.dataset.reviewPage); update(); } });
    window.addEventListener('resize', function () { index = 0; update(); });
    update();
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-review-carousel]').forEach(initReviews); }
  window.__moneyCounterSaleDe = { version: 2, initAll: initAll };
  document.addEventListener('click', function (event) {
    var reviewButton = event.target.closest('[data-review-prev], [data-review-next]');
    if (reviewButton) {
      var reviewSection = reviewButton.closest('[data-money-counter-module="reviews"]');
      var reviewCarousel = reviewSection ? reviewSection.querySelector('[data-review-carousel]') : null;
      if (reviewCarousel) { initReviews(reviewCarousel); reviewCarousel.__moneyCounterReviewStep(reviewButton.matches('[data-review-prev]') ? -1 : 1); }
    }
    var filter = event.target.closest('[data-money-counter-filter]'); if (filter) applyFilter(filter.dataset.moneyCounterFilter);
    var scene = event.target.closest('[data-money-counter-scene]'); if (scene) applyFilter(scene.dataset.moneyCounterScene);
    var category = event.target.closest('[data-compare-category]'); if (category) { var section = category.closest('[data-money-counter-module="comparison"]'); section.querySelectorAll('[data-compare-category]').forEach(function (button) { button.setAttribute('aria-pressed', String(button === category)); }); section.querySelectorAll('[data-compare-panel]').forEach(function (panel) { panel.hidden = panel.dataset.comparePanel !== category.dataset.compareCategory; }); }
    var swatch = event.target.closest('[data-color-image]'); if (swatch) { var head = swatch.closest('th'); var image = head.querySelector('[data-compare-main-image], .money-counter-deals__compare-image img'); if (image) image.src = swatch.dataset.colorImage; swatch.parentElement.querySelectorAll('[data-color-image]').forEach(function (button) { button.classList.toggle('is-active', button === swatch); }); }
  });
  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('[data-review-slide]');
    if (!slide) return;
    var carousel = slide.closest('[data-review-carousel]');
    initReviews(carousel);
    var slides = Array.from(carousel.querySelectorAll('[data-review-slide]'));
    var visible = window.innerWidth <= 700 ? 1 : (window.innerWidth <= 990 ? 2 : 3);
    carousel.__moneyCounterReviewGoTo(Math.floor(slides.indexOf(slide) / visible));
  });
  if (document.readyState !== 'loading') initAll(document);
})();